/* eslint-disable @moka-fe/lingui-mark */
const jobCategory = [
  {
    id: 1,
    name: '互联网',
    children: [
      {
        id: '1.1',
        name: '技术',
        children: [
          {
            id: '1.1.1',
            name: '后端开发',
            children: [
              {
                id: '1.1.1.1',
                name: 'Java',
              },
              {
                id: '1.1.1.2',
                name: 'Python',
              },
              {
                id: '1.1.1.3',
                name: 'PHP',
              },
              {
                id: '1.1.1.4',
                name: '.NET',
              },
              {
                id: '1.1.1.5',
                name: 'C#',
              },
              {
                id: '1.1.1.6',
                name: 'C++',
              },
              {
                id: '1.1.1.7',
                name: 'C',
              },
              {
                id: '1.1.1.8',
                name: 'VB',
              },
              {
                id: '1.1.1.9',
                name: 'Delphi',
              },
              {
                id: '1.1.1.10',
                name: 'Perl',
              },
              {
                id: '1.1.1.11',
                name: 'Ruby',
              },
              {
                id: '1.1.1.12',
                name: 'Hadoop',
              },
              {
                id: '1.1.1.13',
                name: 'Node.js',
              },
              {
                id: '1.1.1.14',
                name: '数据挖掘/大数据',
              },
              {
                id: '1.1.1.15',
                name: '自然语言处理',
              },
              {
                id: '1.1.1.16',
                name: '搜索算法',
              },
              {
                id: '1.1.1.17',
                name: '精准推荐',
              },
              {
                id: '1.1.1.18',
                name: '机器学习',
              },
              {
                id: '1.1.1.19',
                name: '全栈工程师',
              },
              {
                id: '1.1.1.20',
                name: 'Go',
              },
              {
                id: '1.1.1.21',
                name: 'ASP',
              },
              {
                id: '1.1.1.22',
                name: 'Shell',
              },
              {
                id: '1.1.1.23',
                name: '爬虫工程师',
              },
            ],
          },
          {
            id: '1.1.2',
            name: '移动开发',
            children: [
              {
                id: '1.1.2.1',
                name: 'HTML5',
              },
              {
                id: '1.1.2.2',
                name: 'Android',
              },
              {
                id: '1.1.2.3',
                name: 'iOS',
              },
              {
                id: '1.1.2.4',
                name: 'WP',
              },
            ],
          },
          {
            id: '1.1.3',
            name: '前端开发',
            children: [
              {
                id: '1.1.3.1',
                name: 'web前端',
              },
              {
                id: '1.1.3.2',
                name: 'Flash',
              },
              {
                id: '1.1.3.3',
                name: 'HTML5',
              },
              {
                id: '1.1.3.4',
                name: 'JavaScript',
              },
              {
                id: '1.1.3.5',
                name: 'U3D',
              },
              {
                id: '1.1.3.6',
                name: 'COCOS2D-X',
              },
            ],
          },
          {
            id: '1.1.4',
            name: '测试',
            children: [
              {
                id: '1.1.4.1',
                name: '测试工程师',
              },
              {
                id: '1.1.4.2',
                name: '自动化测试',
              },
              {
                id: '1.1.4.3',
                name: '功能测试',
              },
              {
                id: '1.1.4.4',
                name: '性能测试',
              },
              {
                id: '1.1.4.5',
                name: '测试开发',
              },
              {
                id: '1.1.4.6',
                name: '游戏测试',
              },
              {
                id: '1.1.4.7',
                name: '白盒测试',
              },
              {
                id: '1.1.4.8',
                name: '灰盒测试',
              },
              {
                id: '1.1.4.9',
                name: '黑盒测试',
              },
              {
                id: '1.1.4.10',
                name: '手机测试',
              },
              {
                id: '1.1.4.11',
                name: '硬件测试',
              },
              {
                id: '1.1.4.12',
                name: '测试经理',
              },
            ],
          },
          {
            id: '1.1.5',
            name: '运维',
            children: [
              {
                id: '1.1.5.1',
                name: '运维工程师',
              },
              {
                id: '1.1.5.2',
                name: '运维开发工程师',
              },
              {
                id: '1.1.5.3',
                name: '网络工程师',
              },
              {
                id: '1.1.5.4',
                name: '系统工程师',
              },
              {
                id: '1.1.5.5',
                name: 'IT支持',
              },
              {
                id: '1.1.5.6',
                name: 'IDC',
              },
              {
                id: '1.1.5.7',
                name: 'CDN',
              },
              {
                id: '1.1.5.8',
                name: 'F5',
              },
              {
                id: '1.1.5.9',
                name: '系统管理员',
              },
              {
                id: '1.1.5.10',
                name: '病毒分析',
              },
              {
                id: '1.1.5.11',
                name: 'WEB安全',
              },
              {
                id: '1.1.5.12',
                name: '网络安全',
              },
              {
                id: '1.1.5.13',
                name: '运维经理',
              },
            ],
          },
          {
            id: '1.1.6',
            name: 'DBA',
            children: [
              {
                id: '1.1.6.1',
                name: 'MySQL',
              },
              {
                id: '1.1.6.2',
                name: 'SQLServer',
              },
              {
                id: '1.1.6.3',
                name: 'Oracle',
              },
              {
                id: '1.1.6.4',
                name: 'DB2',
              },
              {
                id: '1.1.6.5',
                name: 'MongoDB',
              },
              {
                id: '1.1.6.6',
                name: 'ETL',
              },
              {
                id: '1.1.6.7',
                name: 'Hive',
              },
              {
                id: '1.1.6.8',
                name: '数据仓库',
              },
            ],
          },
          {
            id: '1.1.7',
            name: '高端职位(技术)',
            children: [
              {
                id: '1.1.7.1',
                name: '技术经理',
              },
              {
                id: '1.1.7.2',
                name: '技术总监',
              },
              {
                id: '1.1.7.3',
                name: '架构师',
              },
              {
                id: '1.1.7.4',
                name: 'CTO',
              },
              {
                id: '1.1.7.5',
                name: '运维总监',
              },
              {
                id: '1.1.7.6',
                name: '技术合伙人',
              },
              {
                id: '1.1.7.7',
                name: '项目总监',
              },
              {
                id: '1.1.7.8',
                name: '测试总监',
              },
              {
                id: '1.1.7.9',
                name: '安全专家',
              },
            ],
          },
          {
            id: '1.1.8',
            name: '项目管理',
            children: [
              {
                id: '1.1.8.1',
                name: '项目经理',
              },
              {
                id: '1.1.8.2',
                name: '项目助理',
              },
            ],
          },
          {
            id: '1.1.9',
            name: '硬件开发',
            children: [
              {
                id: '1.1.9.1',
                name: '硬件',
              },
              {
                id: '1.1.9.2',
                name: '嵌入式',
              },
              {
                id: '1.1.9.3',
                name: '自动化',
              },
              {
                id: '1.1.9.4',
                name: '单片机',
              },
              {
                id: '1.1.9.5',
                name: '电路设计',
              },
              {
                id: '1.1.9.6',
                name: '驱动开发',
              },
              {
                id: '1.1.9.7',
                name: '系统集成',
              },
              {
                id: '1.1.9.8',
                name: 'FPGA开发',
              },
              {
                id: '1.1.9.9',
                name: 'DSP开发',
              },
              {
                id: '1.1.9.10',
                name: 'ARM开发',
              },
              {
                id: '1.1.9.11',
                name: 'PCB工艺',
              },
              {
                id: '1.1.9.12',
                name: '模具设计',
              },
              {
                id: '1.1.9.13',
                name: '热传导',
              },
              {
                id: '1.1.9.14',
                name: '材料工程师',
              },
              {
                id: '1.1.9.15',
                name: '精益工程师',
              },
              {
                id: '1.1.9.16',
                name: '射频工程师',
              },
            ],
          },
          {
            id: '1.1.10',
            name: '企业软件',
            children: [
              {
                id: '1.1.10.1',
                name: '实施工程师',
              },
              {
                id: '1.1.10.2',
                name: '售前工程师',
              },
              {
                id: '1.1.10.3',
                name: '售后工程师',
              },
              {
                id: '1.1.10.4',
                name: 'BI工程师',
              },
            ],
          },
        ],
      },
      {
        id: '1.2',
        name: '产品',
        children: [
          {
            id: '1.2.1',
            name: '产品经理',
            children: [
              {
                id: '1.2.1.1',
                name: '产品经理',
              },
              {
                id: '1.2.1.2',
                name: '网页产品经理',
              },
              {
                id: '1.2.1.3',
                name: '移动产品经理',
              },
              {
                id: '1.2.1.4',
                name: '产品助理',
              },
              {
                id: '1.2.1.5',
                name: '数据产品经理',
              },
              {
                id: '1.2.1.6',
                name: '电商产品经理',
              },
              {
                id: '1.2.1.7',
                name: '游戏策划',
              },
              {
                id: '1.2.1.8',
                name: '产品实习生',
              },
            ],
          },
          {
            id: '1.2.2',
            name: '产品设计师',
            children: [
              {
                id: '1.2.2.1',
                name: '网页产品设计师',
              },
              {
                id: '1.2.2.2',
                name: '无线产品设计师',
              },
            ],
          },
          {
            id: '1.2.3',
            name: '高端职位(产品)',
            children: [
              {
                id: '1.2.3.1',
                name: '产品部经理',
              },
              {
                id: '1.2.3.2',
                name: '产品总监',
              },
              {
                id: '1.2.3.3',
                name: '游戏制作人',
              },
            ],
          },
        ],
      },
      {
        id: '1.3',
        name: '设计',
        children: [
          {
            id: '1.3.1',
            name: '视觉设计',
            children: [
              {
                id: '1.3.1.1',
                name: '网页设计师',
              },
              {
                id: '1.3.1.2',
                name: 'Flash设计师',
              },
              {
                id: '1.3.1.3',
                name: 'APP设计师',
              },
              {
                id: '1.3.1.4',
                name: 'UI设计师',
              },
              {
                id: '1.3.1.5',
                name: '平面设计师',
              },
              {
                id: '1.3.1.6',
                name: '美术设计师（2D/3D）',
              },
              {
                id: '1.3.1.7',
                name: '广告设计师',
              },
              {
                id: '1.3.1.8',
                name: '多媒体设计师',
              },
              {
                id: '1.3.1.9',
                name: '原画师',
              },
              {
                id: '1.3.1.10',
                name: '游戏特效',
              },
              {
                id: '1.3.1.11',
                name: '游戏界面设计师',
              },
              {
                id: '1.3.1.12',
                name: '视觉设计师',
              },
              {
                id: '1.3.1.13',
                name: '游戏场景',
              },
              {
                id: '1.3.1.14',
                name: '游戏角色',
              },
              {
                id: '1.3.1.15',
                name: '游戏动作',
              },
            ],
          },
          {
            id: '1.3.2',
            name: '用户研究',
            children: [
              {
                id: '1.3.2.1',
                name: '数据分析师',
              },
              {
                id: '1.3.2.2',
                name: '用户研究员',
              },
              {
                id: '1.3.2.3',
                name: '游戏数值策划',
              },
            ],
          },
          {
            id: '1.3.3',
            name: '高端职位(设计)',
            children: [
              {
                id: '1.3.3.1',
                name: '设计经理/主管',
              },
              {
                id: '1.3.3.2',
                name: '设计总监',
              },
              {
                id: '1.3.3.3',
                name: '视觉设计经理/主管',
              },
              {
                id: '1.3.3.4',
                name: '视觉设计总监',
              },
              {
                id: '1.3.3.5',
                name: '交互设计经理/主管',
              },
              {
                id: '1.3.3.6',
                name: '交互设计总监',
              },
              {
                id: '1.3.3.7',
                name: '用户研究经理/主管',
              },
              {
                id: '1.3.3.8',
                name: '用户研究总监',
              },
            ],
          },
          {
            id: '1.3.4',
            name: '交互设计',
            children: [
              {
                id: '1.3.4.1',
                name: '网页交互设计师',
              },
              {
                id: '1.3.4.2',
                name: '交互设计师',
              },
              {
                id: '1.3.4.3',
                name: '无线交互设计师',
              },
              {
                id: '1.3.4.4',
                name: '硬件交互设计师',
              },
            ],
          },
        ],
      },
      {
        id: '1.4',
        name: '运营',
        children: [
          {
            id: '1.4.1',
            name: '运营',
            children: [
              {
                id: '1.4.1.1',
                name: '内容运营',
              },
              {
                id: '1.4.1.2',
                name: '产品运营',
              },
              {
                id: '1.4.1.3',
                name: '数据运营',
              },
              {
                id: '1.4.1.4',
                name: '用户运营',
              },
              {
                id: '1.4.1.5',
                name: '活动运营',
              },
              {
                id: '1.4.1.6',
                name: '商家运营',
              },
              {
                id: '1.4.1.7',
                name: '品类运营',
              },
              {
                id: '1.4.1.8',
                name: '游戏运营',
              },
              {
                id: '1.4.1.9',
                name: '网络推广',
              },
              {
                id: '1.4.1.10',
                name: '运营专员',
              },
              {
                id: '1.4.1.11',
                name: '网店运营',
              },
              {
                id: '1.4.1.12',
                name: '新媒体运营',
              },
              {
                id: '1.4.1.13',
                name: '海外运营',
              },
              {
                id: '1.4.1.14',
                name: '运营经理',
              },
            ],
          },
          {
            id: '1.4.2',
            name: '编辑',
            children: [
              {
                id: '1.4.2.1',
                name: '副主编',
              },
              {
                id: '1.4.2.2',
                name: '内容编辑',
              },
              {
                id: '1.4.2.3',
                name: '文案策划',
              },
              {
                id: '1.4.2.4',
                name: '记者',
              },
            ],
          },
          {
            id: '1.4.3',
            name: '客服',
            children: [
              {
                id: '1.4.3.1',
                name: '售前咨询',
              },
              {
                id: '1.4.3.2',
                name: '售后客服',
              },
              {
                id: '1.4.3.3',
                name: '淘宝客服',
              },
              {
                id: '1.4.3.4',
                name: '客服经理',
              },
            ],
          },
          {
            id: '1.4.4',
            name: '高端职位(运营)',
            children: [
              {
                id: '1.4.4.1',
                name: '主编',
              },
              {
                id: '1.4.4.2',
                name: '运营总监',
              },
              {
                id: '1.4.4.3',
                name: 'COO',
              },
              {
                id: '1.4.4.4',
                name: '客服总监',
              },
            ],
          },
        ],
      },
      {
        id: '1.5',
        name: '市场与销售',
        children: [
          {
            id: '1.5.1',
            name: '市场/营销',
            children: [
              {
                id: '1.5.1.1',
                name: '市场策划',
              },
              {
                id: '1.5.1.2',
                name: '市场顾问',
              },
              {
                id: '1.5.1.3',
                name: '市场营销',
              },
              {
                id: '1.5.1.4',
                name: '市场推广',
              },
              {
                id: '1.5.1.5',
                name: 'SEO',
              },
              {
                id: '1.5.1.6',
                name: 'SEM',
              },
              {
                id: '1.5.1.7',
                name: '商务渠道',
              },
              {
                id: '1.5.1.8',
                name: '商业数据分析',
              },
              {
                id: '1.5.1.9',
                name: '活动策划',
              },
              {
                id: '1.5.1.10',
                name: '网络营销',
              },
              {
                id: '1.5.1.11',
                name: '海外市场',
              },
              {
                id: '1.5.1.12',
                name: '政府关系',
              },
            ],
          },
          {
            id: '1.5.2',
            name: '公关',
            children: [
              {
                id: '1.5.2.1',
                name: '媒介经理',
              },
              {
                id: '1.5.2.2',
                name: '广告协调',
              },
              {
                id: '1.5.2.3',
                name: '品牌公关',
              },
            ],
          },
          {
            id: '1.5.3',
            name: '销售',
            children: [
              {
                id: '1.5.3.1',
                name: '销售专员',
              },
              {
                id: '1.5.3.2',
                name: '销售经理',
              },
              {
                id: '1.5.3.3',
                name: '客户代表',
              },
              {
                id: '1.5.3.4',
                name: '大客户代表',
              },
              {
                id: '1.5.3.5',
                name: 'BD经理',
              },
              {
                id: '1.5.3.6',
                name: '商务渠道',
              },
              {
                id: '1.5.3.7',
                name: '渠道销售',
              },
              {
                id: '1.5.3.8',
                name: '代理商销售',
              },
              {
                id: '1.5.3.9',
                name: '销售助理',
              },
              {
                id: '1.5.3.10',
                name: '电话销售',
              },
              {
                id: '1.5.3.11',
                name: '销售顾问',
              },
              {
                id: '1.5.3.12',
                name: '商品经理',
              },
            ],
          },
          {
            id: '1.5.4',
            name: '高端职位(市场与销售)',
            children: [
              {
                id: '1.5.4.1',
                name: '市场总监',
              },
              {
                id: '1.5.4.2',
                name: '销售总监',
              },
              {
                id: '1.5.4.3',
                name: '商务总监',
              },
              {
                id: '1.5.4.4',
                name: 'CMO',
              },
              {
                id: '1.5.4.5',
                name: '公关总监',
              },
              {
                id: '1.5.4.6',
                name: '采购总监',
              },
              {
                id: '1.5.4.7',
                name: '投资总监',
              },
            ],
          },
          {
            id: '1.5.5',
            name: '供应链',
            children: [
              {
                id: '1.5.5.1',
                name: '物流',
              },
              {
                id: '1.5.5.2',
                name: '仓储',
              },
            ],
          },
          {
            id: '1.5.6',
            name: '采购',
            children: [
              {
                id: '1.5.6.1',
                name: '采购专员',
              },
              {
                id: '1.5.6.2',
                name: '采购经理',
              },
              {
                id: '1.5.6.3',
                name: '商品经理',
              },
            ],
          },
        ],
      },
      {
        id: '1.6',
        name: '职能',
        children: [
          {
            id: '1.6.1',
            name: '人力资源',
            children: [
              {
                id: '1.6.1.1',
                name: '人事/HR',
              },
              {
                id: '1.6.1.2',
                name: '培训经理',
              },
              {
                id: '1.6.1.3',
                name: '薪资福利经理',
              },
              {
                id: '1.6.1.4',
                name: '绩效考核经理',
              },
              {
                id: '1.6.1.5',
                name: '人力资源',
              },
              {
                id: '1.6.1.6',
                name: '招聘',
              },
              {
                id: '1.6.1.7',
                name: 'HRBP',
              },
              {
                id: '1.6.1.8',
                name: '员工关系',
              },
            ],
          },
          {
            id: '1.6.2',
            name: '行政',
            children: [
              {
                id: '1.6.2.1',
                name: '助理',
              },
              {
                id: '1.6.2.2',
                name: '前台',
              },
              {
                id: '1.6.2.3',
                name: '行政',
              },
              {
                id: '1.6.2.4',
                name: '总裁助理',
              },
              {
                id: '1.6.2.5',
                name: '文秘',
              },
            ],
          },
          {
            id: '1.6.3',
            name: '财务',
            children: [
              {
                id: '1.6.3.1',
                name: '会计',
              },
              {
                id: '1.6.3.2',
                name: '出纳',
              },
              {
                id: '1.6.3.3',
                name: '财务',
              },
              {
                id: '1.6.3.4',
                name: '结算',
              },
              {
                id: '1.6.3.5',
                name: '税务',
              },
              {
                id: '1.6.3.6',
                name: '审计',
              },
              {
                id: '1.6.3.7',
                name: '风控',
              },
            ],
          },
          {
            id: '1.6.4',
            name: '高端职位(职能)',
            children: [
              {
                id: '1.6.4.1',
                name: '行政总监/经理',
              },
              {
                id: '1.6.4.2',
                name: '财务总监/经理',
              },
              {
                id: '1.6.4.3',
                name: 'HRD/HRM',
              },
              {
                id: '1.6.4.4',
                name: 'CFO',
              },
              {
                id: '1.6.4.5',
                name: 'CEO',
              },
            ],
          },
          {
            id: '1.6.5',
            name: '法务',
            children: [
              {
                id: '1.6.5.1',
                name: '法务',
              },
              {
                id: '1.6.5.2',
                name: '律师',
              },
              {
                id: '1.6.5.3',
                name: '专利',
              },
            ],
          },
        ],
      },
      {
        id: '1.7',
        name: '金融',
        children: [
          {
            id: '1.7.1',
            name: '投融资',
            children: [
              {
                id: '1.7.1.1',
                name: '投资经理',
              },
              {
                id: '1.7.1.2',
                name: '分析师',
              },
              {
                id: '1.7.1.3',
                name: '投资助理',
              },
              {
                id: '1.7.1.4',
                name: '融资',
              },
              {
                id: '1.7.1.5',
                name: '并购',
              },
              {
                id: '1.7.1.6',
                name: '行业研究',
              },
              {
                id: '1.7.1.7',
                name: '投资者关系',
              },
              {
                id: '1.7.1.8',
                name: '资产管理',
              },
              {
                id: '1.7.1.9',
                name: '理财顾问',
              },
              {
                id: '1.7.1.10',
                name: '交易员',
              },
            ],
          },
          {
            id: '1.7.2',
            name: '风控',
            children: [
              {
                id: '1.7.2.1',
                name: '风控',
              },
              {
                id: '1.7.2.2',
                name: '资信评估',
              },
              {
                id: '1.7.2.3',
                name: '合规稽查',
              },
              {
                id: '1.7.2.4',
                name: '律师',
              },
            ],
          },
          {
            id: '1.7.3',
            name: '审计税务',
            children: [
              {
                id: '1.7.3.1',
                name: '审计',
              },
              {
                id: '1.7.3.2',
                name: '法务',
              },
              {
                id: '1.7.3.3',
                name: '会计',
              },
              {
                id: '1.7.3.4',
                name: '清算',
              },
            ],
          },
          {
            id: '1.7.4',
            name: '高端职位(金融)',
            children: [
              {
                id: '1.7.4.1',
                name: '投资总监',
              },
              {
                id: '1.7.4.2',
                name: '融资总监',
              },
              {
                id: '1.7.4.3',
                name: '并购总监',
              },
              {
                id: '1.7.4.4',
                name: '风控总监',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: '综合职能',
    children: [
      {
        id: '2.1',
        name: '高级管理',
      },
      {
        id: '2.2',
        name: '人力资源',
      },
      {
        id: '2.3',
        name: '财务/审计/税务',
      },
      {
        id: '2.4',
        name: '市场',
      },
      {
        id: '2.5',
        name: '法务',
      },
      {
        id: '2.6',
        name: '客服/技术支持',
      },
      {
        id: '2.7',
        name: '行政/后勤/文秘',
      },
    ],
  },
  {
    id: 3,
    name: '房地产/建筑/物业',
    children: [
      {
        id: '3.1',
        name: '房地产规划/开发',
      },
      {
        id: '3.2',
        name: '建筑装潢/市政建设',
      },
      {
        id: '3.3',
        name: '房地产交易/中介',
      },
      {
        id: '3.4',
        name: '物业管理',
      },
    ],
  },
  {
    id: 4,
    name: '金融',
    children: [
      {
        id: '4.1',
        name: '银行',
      },
      {
        id: '4.2',
        name: '保险',
      },
      {
        id: '4.3',
        name: '基金/证券/期货/投资',
      },
      {
        id: '4.4',
        name: '信托/担保/拍卖/典当',
      },
    ],
  },
  {
    id: 5,
    name: '生产/制造',
    children: [
      {
        id: '5.1',
        name: '生产/营运',
      },
      {
        id: '5.2',
        name: '生物/制药/医疗器械',
      },
      {
        id: '5.3',
        name: '汽车制造',
      },
      {
        id: '5.4',
        name: '汽车销售与服务',
      },
      {
        id: '5.5',
        name: '电子/电器/半导体/仪器/仪表',
      },
      {
        id: '5.6',
        name: '化工',
      },
      {
        id: '5.7',
        name: '服装/纺织/皮革',
      },
      {
        id: '5.8',
        name: '机械设计/制造/维修',
      },
    ],
  },
  {
    id: 6,
    name: '质量管理/项目管理',
    children: [
      {
        id: '6.1',
        name: '质量管理/安全防护',
      },
      {
        id: '6.2',
        name: '项目管理/项目协调',
      },
    ],
  },
  {
    id: 7,
    name: '教育/咨询/翻译',
    children: [
      {
        id: '7.1',
        name: '教育/培训',
      },
      {
        id: '7.2',
        name: '咨询/调研',
      },
      {
        id: '7.3',
        name: '翻译',
      },
    ],
  },
  {
    id: 8,
    name: '广告/传媒/设计',
    children: [
      {
        id: '8.1',
        name: '广告/会展',
      },
      {
        id: '8.2',
        name: '影视/媒体',
      },
      {
        id: '8.3',
        name: '写作/采编/出版/印刷',
      },
      {
        id: '8.4',
        name: '艺术/设计',
      },
    ],
  },
  {
    id: 9,
    name: '采购/贸易/交通/物流',
    children: [
      {
        id: '9.1',
        name: '采购/贸易',
      },
      {
        id: '9.2',
        name: '交通运输服务',
      },
      {
        id: '9.3',
        name: '物流/仓储',
      },
    ],
  },
  {
    id: 10,
    name: '医疗护理/生活服务',
    children: [
      {
        id: '10.1',
        name: '医院/医疗/护理',
      },
      {
        id: '10.2',
        name: '百货/连锁/零售服务',
      },
      {
        id: '10.3',
        name: '酒店/餐饮/娱乐/生活服务',
      },
      {
        id: '10.4',
        name: '旅游/出入境服务',
      },
    ],
  },
  {
    id: 11,
    name: '能源/矿产/环保',
    children: [
      {
        id: '11.1',
        name: '电力/能源/矿产/地质勘查',
      },
      {
        id: '11.2',
        name: '环境科学/环保',
      },
    ],
  },
  {
    id: 12,
    name: '公务员/农林牧渔/其他',
    children: [
      {
        id: '12.1',
        name: '公务员/公益事业/科研',
      },
      {
        id: '12.2',
        name: '农/林/牧/渔',
      },
      {
        id: '12.3',
        name: '实习生/培训生/储备干部',
      },
      {
        id: '12.4',
        name: '其他',
      },
    ],
  },
];

export default jobCategory;
